import { MarkdownRenderer } from '@src/app-components/markdown-renderer/MarkdownRenderer';
import { RequestType } from '@src/utils/enums';
import { Alert } from '@trussworks/react-uswds';
import React from 'react';

type PermitProcessGuideProps = {
  result: RequestType | string;
};

const requestTypes: string[] = [
  RequestType.AquaticResourceDelineationReportAndInventory,
  RequestType.JurisdictionalDetermination,
  RequestType.NonPreconstructionNotification,
  RequestType.NoPermitRequired,
  RequestType.PermitApplication,
  RequestType.PreApplication,
];

export const getResultText = (result: RequestType | string) => {
  if (requestTypes.includes(result)) {
    return `Please create a new request and select the **${result}** Request Type`;
  }
  return result;
};

const PermitProcessGuideSuggest: React.FC<PermitProcessGuideProps> = ({ result }) => {
  return (
    <Alert type='info' slim noIcon className='margin-bottom-2' headingLevel='h6'>
      <MarkdownRenderer text={`${getResultText(result)}.`} />
    </Alert>
  );
};
export default PermitProcessGuideSuggest;
